import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { expenseReportQueryConfig } from '@webapp/modules/expense/query-configs/expenseReport'

interface EditExpenseReportMutationParams {
  expenseId: number
  uuid: string
  payload: {
    title: string
    travel: Nullable<number>
    notes: string
  }
}

export const useMutateEditExpenseReport = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    void,
    RepoError,
    EditExpenseReportMutationParams
  >({
    mutationFn: ({ expenseId, payload }) =>
      expenseRepository.update(expenseId, payload),

    onSuccess: (_data, { uuid }) => {
      queryClient.invalidateQueries({
        queryKey: expenseReportQueryConfig.detail(uuid).queryKey,
      })
    },
  })

  return {
    mutate: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
  }
}
